/*
 * Epic messages
 *
 * This contains all the text for the epics
 */

import { defineMessages } from 'react-intl';

export default defineMessages({
  paymentError: {
    id: 'errors.payment.error',
    defaultMessage:
      'There was an error during payment. Please try a different payment method.',
  },
  pendingExpired: {
    id: 'errors.payment.expired',
    defaultMessage: 'The payment session has expired. Please try again.',
  },
});
